window.swipers = [];

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.options = this.getAttribute('data-swiper') ? JSON.parse(this.getAttribute('data-swiper')) : {};
    // If the .swiper-slider element is not rendered yet
    // it could be necessary to add a timeout here.
    this.sliderSelector = this.querySelector('.swiper-slider')
    if (this.sliderSelector) {
      const swiper = new Swiper(this.sliderSelector, this.options);
      swiper && window.swipers.push(swiper);
    }
    this.pillsSlider();
    this.designerSlider();
  }

  pillsSlider(){
    if(this.querySelector(".pills.swiper")){
      const overlay = this.querySelector(".opacity-component");
      const swiperPills = new Swiper('.swiper.pills', {
        spaceBetween: 10,
        slidesPerView: "auto",
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },

        breakpoints:{
          1024:{
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          }
        },

        on: {
          init: function () {
            console.log('swiper initialized');
          },
        },
        on: {
          afterInit: function(){
            if(this.isLocked){
              this.el.closest(".pills-container").classList.add("is-locked");
            }
          }
        }
      });
      if(swiperPills.isEnd){
        if(!overlay.classList.contains("hide")){
          overlay.classList.add("hide");
        }
      }
      swiperPills.on('reachEnd',() => {
        if(!overlay.classList.contains("hide")){
          overlay.classList.add("hide");
        }
      });
      swiperPills.on("transitionEnd", () => {
        if(!swiperPills.isEnd){
          if(overlay.classList.contains("hide")){
            overlay.classList.remove("hide");
          }
        }
      });
    }
  }

  designerSlider(){
    const swiper = window.swipers.find( s => (s.el.matches(".letters-slider")))
    if (swiper) {
      swiper.on('reachEnd', () => {
        if(!this.querySelector(".opacity-component").classList.contains("hide")){
          this.querySelector(".opacity-component").classList.add("hide");
        }
      });
      swiper.on('slidePrevTransitionEnd', () => {
        if(this.querySelector(".opacity-component").classList.contains("hide")){
          this.querySelector(".opacity-component").classList.remove("hide");
        }
      });
    }
  }
}

customElements.define('swiper-slider', SwiperSlider);
